// tslint:disable:no-null-keyword
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
var _SceneManagerDOM = function (_a) {
    var currentScene = _a.currentScene;
    if (currentScene == undefined || currentScene.domComponent == undefined) {
        return null;
    }
    var Scene = currentScene.domComponent;
    return React.createElement(Scene, null);
};
var mapState = function (state) { return (__assign({}, state.scenes, { lang: state.loca.lang })); };
export var SceneManagerDOM = connect(mapState)(_SceneManagerDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/scenes/SceneManagerDOM.tsx
// module id = 1373
// module chunks = 3